import React from 'react';
import { Navigate } from 'react-router-dom';
import { useRegistration } from '../store/RegistrationContext';

export default function AssignSessionsPage() {
  const { state } = useRegistration();

  if (state.selectedRetreatId) {
    return <Navigate to={`/retreat/${state.selectedRetreatId}`} replace />;
  }

  return <Navigate to="/retreat" replace />;
}
